import { createMuiTheme } from "@material-ui/core/styles";

declare module "@material-ui/core/styles/createPalette" {
  interface Palette {
    neutral: Palette['primary'];
  }
  interface PaletteOptions {
    neutral: PaletteOptions['primary'];
  }
}
export const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#F22B0C',
    },
    secondary: {
      main: '#0c60f2',
    },
    info: {
      main: '#999999',
    },
    neutral: {
      main: '#666666',
      light: '#cccccc',
      dark: '#000000',
    },
    background: {
      paper: '#FFFFFF',
    },
  },
  typography: {
    fontSize: 13,
  },
  overrides: {
    MuiFormControlLabel: {
      label: {
        fontFamily: 'Calibri',
        fontWeight: 300,
      }
    }
  },
});